import { ContactDto } from "@/constants/types";
import requests from "../axios";

export const GlobalServices = {
  contactUs: async (body:ContactDto) => {
    return requests.post(`/contact-us`, body);
  },
  getHomeData: async (lang: any) => {
    return requests.get(`/${lang}/home`);
  },
  getSettings: async (lang: any) => {
    return requests.get(`/${lang}/settings`);
  },
  getPostsWithoutPagination: async (lang: string, type: string) => {
    return requests.get(`/${lang}/posts/${type}`);
  },
  getPost: async (lang: string, type: string, slug: string) => {
    return requests.get(`/${lang}/posts/${type}/${slug}`);
  },
  getRecentPosts: async (lang: string, type: string, slug: string) => {
    return requests.get(`/${lang}/recent-posts/${type}/${slug}`);
  },
  getPostsWithPagination: async (
    lang: string,
    type: string,
    currentPage: number = 1,
    limit: number = 3
  ) => {
    return requests.get(
      `/${lang}/posts-with-pagination/${type}?limit=${limit}&page=${currentPage}`
    );
  },

  getTeam: async () => {
    return requests.get(`/fr/team`);
  },
  getBlogData: async (
    lang: any,
    { currentPage, category }: { currentPage?: any; category?: any }
  ) => {
    return requests.get(
      `/${lang}/blog${
        category
          ? `?category=${category}&page=${currentPage}`
          : `?page=${currentPage}`
      }`
    );
  },

  getSearchData: async (
    lang: any,
    { currentPage, search }: { currentPage?: any; search?: any }
  ) => {
    return requests.get(
      `/${lang}/search${
        search
          ? `?search=${search}&page=${currentPage}`
          : `?page=${currentPage}`
      }`
    );
  },
  getActivities: async (
    lang: any,
    { currentPage, category }: { currentPage?: any; category?: any }
  ) => {
    return requests.get(
      `/${lang}/settings/activities${
        category
          ? `?category=${category}&page=${currentPage}`
          : `?page=${currentPage}`
      }`
    );
  },
  getEvents: async (
    lang: any,
    { currentPage, category }: { currentPage?: any; category?: any }
  ) => {
    return requests.get(
      `/${lang}/events${
        category
          ? `?category=${category}&page=${currentPage}`
          : `?page=${currentPage}`
      }`
    );
  },

  getMedia: async ({
    currentPage,
    type,
  }: {
    currentPage?: any;
    type?: any;
  }) => {
    return requests.get(`/fr/media/${type}?page=${currentPage}`);
  },
  getActivity: async (lang: any, slug?: any) => {
    return requests.get(`/${lang}/activity/${slug}`);
  },
  getEvent: async (lang: any, slug?: any) => {
    return requests.get(`/${lang}/event/${slug}`);
  },
  getImages: async () => {
    return requests.get(`/fr/settings/images`);
  },

  getAboutPage: async (lang: any) => {
    return requests.get(`/${lang}/settings/about`);
  },
};
